import { AUTHENTICATED_EMPLOYEE_JWT } from "../constants";

export const useSetAuthenticatedEmployee = (encodedJwt: string) => {
  return window.localStorage.setItem(AUTHENTICATED_EMPLOYEE_JWT, encodedJwt);
};
